module.exports = __webpack_public_path__ + "static/img/get-perked-logo-org-prpl-250.a2339bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/get-perked-logo-org-prpl-250.png
// module id = qIix
// module chunks = 44